import script from "./SuggestionList.vue?vue&type=script&setup=true&lang=js"
export * from "./SuggestionList.vue?vue&type=script&setup=true&lang=js"

import "./SuggestionList.vue?vue&type=style&index=0&id=2278e31d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2278e31d"]])

export default __exports__